var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('b-overlay',{attrs:{"show":_vm.showOverlay,"no-wrap":"","opacity":"0.2","fixed":true,"z-index":"2000"}}),_c('confirmation-modal',{attrs:{"visible":_vm.showConfirmationModal}}),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }